module.exports = __webpack_public_path__ + "cb0556f98c10768fe3ce7ed1945f6e5b.png";